import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, ExpandedTooltip, Icon, InputWithIcon, toast
// SelectMenu,
} from '@livable/saas-react-components';
import { Button, FormHelperText, FormControl, Grid, InputLabel, IconButton, InputAdornment, OutlinedInput, Paper, TextField, Typography
// MenuItem,
} from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailedStreetFinder } from 'src/components/general/DetailedStreetFinder';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { propertyInformationSchema, propertyInformationSchemaV2 } from 'src/utils/formValidation/AddNewProperty';
import { translate } from 'src/utils/translator';
import { PROPERTY_STEPS, APPFOLIO_PROPERTY_STEPS } from 'src/constants/property';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { USER_ROLES_BY_NAME, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
// import { ManageAccessForm } from 'src/components/shared/ManageAccessModal/ManageAccessForm';
import { PropertyPortfolioTagsBlock } from 'src/components/shared/PropertyPortfolioTagsBlock';
import { useNavigate } from 'react-router-dom';
export const PropertyInformationPage = observer(_ref => {
  let _ref$handleStep = _ref.handleStep,
    handleStep = _ref$handleStep === void 0 ? () => {} : _ref$handleStep,
    editMode = _ref.editMode,
    mutablePropertyId = _ref.mutablePropertyId,
    notCompletedPropertyId = _ref.notCompletedPropertyId,
    predefinedPortfolioId = _ref.predefinedPortfolioId,
    registerActionBack = _ref.registerActionBack,
    registerActionNext = _ref.registerActionNext;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const navigate = useNavigate();
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    buildingId = _useState2[0],
    setBuildingId = _useState2[1];
  const _useState3 = useState(predefinedPortfolioId || store.addNewProperty.portfolioId || null),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPortfolioId = _useState4[0],
    setCurrentPortfolioId = _useState4[1];
  const _useState5 = useState(store.addNewProperty.portfolioIds || []),
    _useState6 = _slicedToArray(_useState5, 2),
    assignedPortfolioIds = _useState6[0],
    setAssignedPortfoliosIds = _useState6[1];
  // const [isAssignPortfolioToPropertyModalOpen, setIsAssignPortfolioToPropertyModalOpen] = useState(false);
  // const [companyPortfolios, setCompanyPortfolios] = useState([]);
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    handleStartValidate = _useState8[0],
    setHandleStartValidate = _useState8[1];
  const _useState9 = useState({}),
    _useState0 = _slicedToArray(_useState9, 2),
    defaultPropertyAddress = _useState0[0],
    setDefaultPropertyAddress = _useState0[1];
  // const [portfoliosSearchKey, setPortfoliosSearchKey] = useState('');
  // const [grantedTeamMembersIds, setGrantedTeamMembersIds] = useState(store.addNewProperty.accountAccess || []);

  const CURRENT_STEPS = store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS : PROPERTY_STEPS;
  const ownershipText = t('add_new_property_flow.ownership_entity_hint');
  const propertyInformationFromSubmit = async () => {
    if (store.company.companyFeatureStore.isAppfolio) {
      if (!notCompletedPropertyId) {
        await store.properties.updatePropertySetupProgressAsync.run({
          propertyId: localStorage.getItem('livable_property_id'),
          propertySetupStep: Object.keys(CURRENT_STEPS).find(key => CURRENT_STEPS[key] === CURRENT_STEPS.PropertyInformation)
        });
      }
      store.addNewProperty.changeCompletedStep(CURRENT_STEPS.UtilityConfiguration);
      handleStep(CURRENT_STEPS.UtilityConfiguration)();
    } else {
      setHandleStartValidate(true);
    }
  };
  const propertyInformationFrom = useFormik({
    initialValues: store.addNewProperty.propertyInformation,
    validationSchema: store.company.companyFeatureStore.readOnlyPropertyPropertyInfo ? propertyInformationSchemaV2 : propertyInformationSchema,
    enableReinitialize: true,
    onSubmit: propertyInformationFromSubmit
  });
  const getExistingPortfolioId = async () => {
    if (store.account.featureFlagsStore.getIsMultiAccountAccessEnabled) {
      var _store$homeDashboardS;
      const resp = await ((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.fetchCompanyPortfoliosData({}));
      return resp;
    } else {
      const resp = await store.portfolios.getExistingPortfoliosAsync.run();
      return resp;
    }
  };

  // const handlePropertyAccess = async propertyId => {
  //   return store.account.assignResourceTeamMemberAsync.run({
  //     propertyId: propertyId,
  //     portfolioId: null,
  //     accountIds: grantedTeamMembersIds,
  //   });
  // };

  // const handleNewPortfolioCreate = async () => {
  //   const resp = await store.portfolios.createPortfolioAsync.run({ name: portfoliosSearchKey });
  //   const createdPortfolioId = resp?.response;
  //
  //   setCurrentPortfolioId(createdPortfolioId);
  //
  //   getExistingPortfolioId().then(async response => {
  //     if (response && response.response) {
  //       // setCompanyPortfolios(
  //       //   response.response.map(i => {
  //       //     return { ...i, name: i.value, id: i.key };
  //       //   })
  //       // );
  //     }
  //   });
  //   toast('success', { body: ['New portfolios successfully created!'] });
  // };

  const handleStartSubmitting = async resultId => {
    const data = {
      propertyAddress: propertyInformationFrom.values.propertyAddress,
      ownership: propertyInformationFrom.values.ownership,
      website: '',
      buildings: [{
        buildingAddress: propertyInformationFrom.values.propertyAddress,
        rentControl: true
      }]
    };
    if (resultId) {
      data.addressId = resultId;
      data.buildings[0].buildingAddressId = resultId;
    }
    if (propertyInformationFrom.values.buildingSquare && propertyInformationFrom.values.buildingSquare !== 'null') {
      data.buildings[0].buildingSquare = +propertyInformationFrom.values.buildingSquare;
    }
    let resp;
    if (store.properties.createNewPropertyAsync.hasEverBeenRun && !store.properties.createNewPropertyAsync.error && localStorage.getItem('livable_property_id') || editMode && mutablePropertyId || notCompletedPropertyId) {
      data.buildings[0].buildingId = buildingId;
      data.propertyId = mutablePropertyId ? mutablePropertyId : notCompletedPropertyId ? notCompletedPropertyId : localStorage.getItem('livable_property_id');
      resp = await store.properties.updatePropertyAsync.run(data);
      if (store.account.featureFlagsStore.getIsMultiAccountAccessEnabled) {
        await store.portfolios.editPropertyPortfoliosRelationshipAsync.run({
          propertyId: data.propertyId,
          portfolioIds: assignedPortfolioIds.filter(propertyPortfolioId => {
            var _store$homeDashboardS2;
            return ((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.companyPortfolioDataDetails(propertyPortfolioId)) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.isDefault) !== true;
          })
        }).then(editPropertyPortfoliosRelationshipAsyncResp => {
          if (editPropertyPortfoliosRelationshipAsyncResp !== null && editPropertyPortfoliosRelationshipAsyncResp !== void 0 && editPropertyPortfoliosRelationshipAsyncResp.isSuccessful) {
            if (!assignedPortfolioIds.includes(store.homeDashboardStore.selectedPortfolioId)) {
              var _store$homeDashboardS3;
              const replacementPortfolioId = (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.findReplacementPortfolioId(store.homeDashboardStore.selectedPortfolioId, data.propertyId);
              if (!replacementPortfolioId) {
                store.homeDashboardStore.selectActivePortfolioId('all');
                store.homeDashboardStore.selectActivePropertyId('all', false);
                navigate("/active_dashboard", {
                  replace: true
                });
              } else {
                store.homeDashboardStore.selectActivePortfolioId(replacementPortfolioId);
                store.homeDashboardStore.selectActivePropertyId(data.propertyId, false);
              }
            }
            toast('success', {
              body: ['Successfully updated!']
            });
          }
          // fetchPropertyInformation();
        });
        // await store.portfolios.transferPortfoliosAsync.run({
        //   targetPortfolioId: currentPortfolioId,
        //   propertyIds: [data.propertyId],
        // });
        //
        // await handlePropertyAccess(data.propertyId);
      }
    } else {
      data.portfolioId = currentPortfolioId;
      data.portfolioIds = assignedPortfolioIds.filter(i => !!i);
      resp = await store.properties.createNewPropertyAsync.run(data);
      if (resp && resp.isSuccessful) {
        var _resp;
        const propertyId = (_resp = resp) === null || _resp === void 0 ? void 0 : _resp.response;
        await store.teamMembers.getCompanyTeamMembersAsync.run({
          companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
        });
        const viewerTeamMemberId = store.addNewProperty.contactInformation.teammembers.find(contactItem => {
          return contactItem.userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder;
        });
        const teamMemberData = {
          propertyId: propertyId,
          data: {
            toCreate: [{
              teamMemberId: viewerTeamMemberId === null || viewerTeamMemberId === void 0 ? void 0 : viewerTeamMemberId.id,
              contactType: 'Building'
            }, {
              teamMemberId: viewerTeamMemberId === null || viewerTeamMemberId === void 0 ? void 0 : viewerTeamMemberId.id,
              contactType: 'Utility'
            }],
            toDelete: []
          }
        };
        await store.properties.updatePropertysContactsAsync.run(teamMemberData);
        if (store.account.featureFlagsStore.getIsMultiAccountAccessEnabled) {
          // await handlePropertyAccess(propertyId);
        }
      }
    }
    if (resp && resp.isSuccessful) {
      if (!mutablePropertyId) {
        await getExistingPortfolioId();
        if (!notCompletedPropertyId) {
          var _resp2, _resp3;
          await store.properties.updatePropertySetupProgressAsync.run({
            propertyId: (_resp2 = resp) !== null && _resp2 !== void 0 && _resp2.response ? (_resp3 = resp) === null || _resp3 === void 0 ? void 0 : _resp3.response : localStorage.getItem('livable_property_id'),
            propertySetupStep: Object.keys(CURRENT_STEPS).find(key => CURRENT_STEPS[key] === CURRENT_STEPS.PropertyInformation)
          });
        }
        store.addNewProperty.changeCompletedStep(CURRENT_STEPS.FeeSetup);
        handleStep(CURRENT_STEPS.FeeSetup)();
      }
      if (mutablePropertyId) {
        toast('success', {
          body: ['Successfully saved']
        });
      }
      if (!(registerActionBack === undefined && registerActionNext === undefined)) {
        await store.portfolios.getPortfoliosDashboardAsync.run({
          storeCompany: true
        }).then(getPortfoliosDashboardAsyncResp => {
          if (getPortfoliosDashboardAsyncResp && getPortfoliosDashboardAsyncResp.isSuccessful) {
            var _ref2, _resp4;
            store.homeDashboardStore.selectActivePropertyId((_ref2 = mutablePropertyId !== null && mutablePropertyId !== void 0 ? mutablePropertyId : notCompletedPropertyId) !== null && _ref2 !== void 0 ? _ref2 : (_resp4 = resp) === null || _resp4 === void 0 ? void 0 : _resp4.response, false);
          }
        });
      }
    }
  };
  useEffect(() => {
    if (registerActionBack !== undefined) registerActionBack(() => {
      handleStep(0)().then(() => {});
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionBack]);
  useEffect(() => {
    if (registerActionNext !== undefined) registerActionNext(() => {
      propertyInformationFromSubmit();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionNext]);
  useEffect(() => {
    getExistingPortfolioId().then(async response => {
      if (response && response.response) {
        if (currentPortfolioId || store.addNewProperty.portfolioId) {
          if (currentPortfolioId === null) setCurrentPortfolioId(store.addNewProperty.portfolioId);

          // const matchingPortfolio = response.response.find(
          //   i => i.key === currentPortfolioId || i.key === store.addNewProperty.portfolioId
          // );
          // setCurrentPortfolio({ ...matchingPortfolio, name: matchingPortfolio.value, id: matchingPortfolio.key });
        } else {
          var _singleElementOfArray;
          setCurrentPortfolioId((_singleElementOfArray = singleElementOfArray(response.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.key);
          // setCurrentPortfolio(
          //   singleElementOfArray(
          //     response.response.map(i => {
          //       return { ...i, name: i.value, id: i.key };
          //     })
          //   )
          // );
        }
        if (!editMode && (assignedPortfolioIds === null || assignedPortfolioIds === void 0 ? void 0 : assignedPortfolioIds.length) === 0) {
          var _response$response$fi;
          const portfolioIds = [(_response$response$fi = response.response.find(i => i.isDefault)) === null || _response$response$fi === void 0 ? void 0 : _response$response$fi.key];
          if (store.account.featureFlagsStore.getIsMultiAccountAccessEnabled) {
            if (!portfolioIds.includes(store.homeDashboardStore.selectedPortfolioId) && store.homeDashboardStore.selectedPortfolioId !== 'all') portfolioIds.push(store.homeDashboardStore.selectedPortfolioId);
          }
          setAssignedPortfoliosIds(portfolioIds);
        }
        // setCompanyPortfolios(
        //   response.response.map(i => {
        //     return { ...i, name: i.value, id: i.key };
        //   })
        // );
      }
      if (localStorage.getItem('livable_property_id') || mutablePropertyId || notCompletedPropertyId) {
        var _currentProperty$resp;
        const currentProperty = await store.properties.getPropertyAsync.run({
          propertyId: localStorage.getItem('livable_property_id') || mutablePropertyId || notCompletedPropertyId
        });
        if (currentPortfolioId === null) setCurrentPortfolioId(currentProperty === null || currentProperty === void 0 || (_currentProperty$resp = currentProperty.response) === null || _currentProperty$resp === void 0 ? void 0 : _currentProperty$resp.portfolioId);
        // const matchingPortfolio = response.response.find(
        //   i => i.key === currentPortfolioId || i.key === currentProperty.response.portfolioId
        // );
        // setCurrentPortfolio({ ...matchingPortfolio, name: matchingPortfolio.value, id: matchingPortfolio.key });

        if (currentProperty && currentProperty.response.addressId) {
          const addressResp = await store.address.batchGetAddressesAsync.run({
            addressIds: [currentProperty.response.addressId]
          });
          if (addressResp && addressResp.isSuccessful) {
            setDefaultPropertyAddress(addressResp.response[0]);
          }
        }
      }
      if (localStorage.getItem('livable_property_id') || mutablePropertyId || notCompletedPropertyId) {
        var _singleElementOfArray2;
        const buildingsData = await store.buildings.getBuildingAsync.run({
          propertyId: localStorage.getItem('livable_property_id') || mutablePropertyId || notCompletedPropertyId
        });
        setBuildingId((_singleElementOfArray2 = singleElementOfArray(buildingsData === null || buildingsData === void 0 ? void 0 : buildingsData.response)) === null || _singleElementOfArray2 === void 0 ? void 0 : _singleElementOfArray2.id);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getIsNetworkLoading = () => {
    return store.units.getUnitsAsync.inProgress || store.account.getProfileAsync.inProgress || store.fees.getExistingFeesAsync.inProgress || store.address.addNewAddressAsync.inProgress || store.address.updateAddressAsync.inProgress || store.buildings.getBuildingAsync.inProgress || store.properties.getPropertyAsync.inProgress || store.address.batchGetAddressesAsync.inProgress || store.properties.updatePropertyAsync.inProgress || store.properties.getPropertyFeesAsync.inProgress || store.properties.createNewPropertyAsync.inProgress || store.properties.getPropertyFeesV2Async.inProgress || store.properties.getPropertysContactsAsync.inProgress || store.portfolios.getExistingPortfoliosAsync.inProgress || store.teamMembers.getCompanyTeamMembersAsync.inProgress || store.properties.getPropertySetupProgressAsync.inProgress || store.inUnitAmenities.getAllInUnitAmenitiesAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.portfolios.transferPortfoliosAsync.inProgress || store.utilityProviders.getUtilityProvidersAsync.inProgress || store.account.assignResourceTeamMemberAsync.inProgress || store.portfolios.createPortfolioAsync.inProgress;
  };
  const PortfolioLabelsList = observer(() => {
    var _store$properties$get, _store$portfolios$edi, _store$homeDashboardS5, _store$homeDashboardS6;
    return /*#__PURE__*/React.createElement(PropertyPortfolioTagsBlock, {
      key: "PropertyInformation_PropertyPortfolioTagsBlock",
      addPortfolioEnabled: true,
      propertyAddress: propertyInformationFrom.values.propertyAddress,
      propertySelectedPortfolioListIds: assignedPortfolioIds,
      updateSelectedPortfoliosCallBack: data => {
        if (editMode) {} else {
          setAssignedPortfoliosIds(data);
        }
      },
      getPortfolioDetailsHandler: id => {
        var _store$homeDashboardS4;
        return (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.companyPortfolioDataDetails(id);
      },
      removePortfolioActionHandler: portfolioId => {
        if (editMode) {} else {
          setAssignedPortfoliosIds(assignedPortfolioIds.filter(i => i !== portfolioId));
        }
      },
      isLoading: ((_store$properties$get = store.properties.getPropertyAsync.inProgressUnicIds) === null || _store$properties$get === void 0 ? void 0 : _store$properties$get.includes(store.homeDashboardStore.selectedPropertyId)) || ((_store$portfolios$edi = store.portfolios.editPropertyPortfoliosRelationshipAsync) === null || _store$portfolios$edi === void 0 ? void 0 : _store$portfolios$edi.inProgress) || editMode && (!((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentProperty) !== null && _store$homeDashboardS5 !== void 0 && (_store$homeDashboardS5 = _store$homeDashboardS5.propertyInformation) !== null && _store$homeDashboardS5 !== void 0 && _store$homeDashboardS5.portfolioIds) || ((_store$homeDashboardS6 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.propertyInformation) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.portfolioIds) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.length) === 0)
    });
  });
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: propertyInformationFrom.handleSubmit
  }, /*#__PURE__*/React.createElement(Paper, {
    variant: "formWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.property_information')), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.property_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    name: "propertyAddress",
    disabled: store.company.companyFeatureStore.readOnlyPropertyPropertyInfo,
    defaultPropertyAddress: defaultPropertyAddress,
    validator: propertyInformationFrom,
    error: !!propertyInformationFrom.errors.propertyAddress,
    helperText: translate(propertyInformationFrom.errors.propertyAddress, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    onBlur: propertyInformationFrom.handleBlur,
    onChange: e => {
      propertyInformationFrom.handleChange(e);
      if (!propertyInformationFrom.touched.ownership && e.target.value.trim().length > 1) {
        setTimeout(() => {
          propertyInformationFrom.setFieldTouched('ownership', true);
        }, 0);
      }
    },
    error: propertyInformationFrom.touched.ownership && Boolean(propertyInformationFrom.errors.ownership)
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "user-location"
    })
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, t('add_new_property_flow.ownership_entity')), /*#__PURE__*/React.createElement(OutlinedInput, {
    fullWidth: true,
    type: "text",
    id: "ownership",
    name: "ownership",
    label: t('add_new_property_flow.ownership_entity'),
    value: propertyInformationFrom.values.ownership,
    disabled: store.company.companyFeatureStore.readOnlyPropertyPropertyInfo || store.properties.createNewPropertyAsync.inProgress || store.properties.updatePropertyAsync.inProgress,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      type: "infoTooltip"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: ownershipText,
      type: "grey"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "question"
    }))))
  }), propertyInformationFrom.touched.ownership && !!propertyInformationFrom.errors.ownership && /*#__PURE__*/React.createElement(FormHelperText, null, translate(propertyInformationFrom.errors.ownership, t)))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.property_square_footage')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    className: classes.xsSection
  }, t('add_new_property_flow.square_footage_is_required')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "building"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.square_ft'),
    variant: "outlined",
    fullWidth: true,
    type: "text",
    id: "buildingSquare",
    name: "buildingSquare",
    disabled: store.company.companyFeatureStore.readOnlyPropertyPropertyInfo || store.properties.createNewPropertyAsync.inProgress || store.properties.updatePropertyAsync.inProgress,
    value: propertyInformationFrom.values.buildingSquare,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onBlur: propertyInformationFrom.handleBlur,
    onChange: e => {
      if (!/^[1-9][0-9]*$|^$/.test(e.target.value)) return;
      propertyInformationFrom.handleChange(e);
    },
    error: propertyInformationFrom.touched.buildingSquare && Boolean(propertyInformationFrom.errors.buildingSquare),
    helperText: propertyInformationFrom.touched.buildingSquare && propertyInformationFrom.errors.buildingSquare
  })))))), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.select_portfolio')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    className: classes.xsSection
  }, t('add_new_property_flow.select_portfolio_description'))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(PortfolioLabelsList, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(FormControl, {
    id: 'property-portfolio-selector',
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: getIsNetworkLoading()
  })), !editMode && registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("span", null), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Button, {
    onClick: handleStep(0),
    variant: "text",
    disabled: getIsNetworkLoading(),
    'custom-attribute': '108-property-information-page'
  }, t('general.back'), ": ", t('general.welcome')), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "priority",
    disabled: !propertyInformationFrom.isValid || !Object.keys(propertyInformationFrom.touched).length && !localStorage.getItem('livable_property_id') && !notCompletedPropertyId || getIsNetworkLoading(),
    'custom-attribute': '109-property-information-page'
  }, store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, t('buttons.confirm'), ". ", t('general.next')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, t('general.next'), ":", ' ', t('add_new_property_flow.fee_structure')))), editMode && /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "priority",
    disabled: !propertyInformationFrom.isValid || getIsNetworkLoading(),
    'custom-attribute': '110-property-information-page'
  }, t('buttons.save')));
});
PropertyInformationPage.propTypes = {
  handleStep: PropTypes.func
};